import { httpService } from 'core-utilities';
import { eventStreamService } from 'core-roblox-utilities';
import {
  startVeriffIdVerificationUrlConfig,
  getVerificationStatusUrlConfig,
  getVerifiedAgeUrlConfig,
  getShowOverlayUrlConfig
} from '../constants/urlConstants';

export const startVeriffIdVerification = isUniversalApp => {
  const urlConfig = startVeriffIdVerificationUrlConfig();
  const params = { generateLink: isUniversalApp };
  return httpService.post(urlConfig, params).then(
    ({ data }) => {
      return data;
    },
    () => {
      return false;
    }
  );
};

export const getVerifiedAge = () => {
  const urlConfig = getVerifiedAgeUrlConfig();
  return httpService.get(urlConfig).then(({ data }) => {
    return data;
  });
};

export const getVerificationStatus = token => {
  const urlConfig = getVerificationStatusUrlConfig();
  const params = { token };
  return httpService.get(urlConfig, params).then(({ data }) => {
    return data;
  });
};

export const sendIdVerificationEvent = (event, params) => {
  eventStreamService.sendEventWithTarget(event.type, event.context, {
    ...event.params,
    origin: params.origin
  });
};

export const startVerificationFlow = () =>
  new Promise(resolve => {
    const event = new CustomEvent('OpenIdentityVerificationModal', {
      detail: {
        successCallback: (isUserOldEnough, didVerifyAge) => {
          resolve([isUserOldEnough, didVerifyAge]);
        }
      }
    });
    window.dispatchEvent(event);
  });

export const showBirthdayChangeWarning = () =>
  new Promise(resolve => {
    const event = new CustomEvent('OpenBirthdayChangeWarning', {
      detail: {
        closeCallback: confirmChange => {
          resolve(confirmChange);
        }
      }
    });
    window.dispatchEvent(event);
  });

export const postShowOverlay = showOverlay => {
  const urlConfig = getShowOverlayUrlConfig();
  const params = { showOverlay };
  return httpService.post(urlConfig, params).then(({ data }) => {
    return data;
  });
};
